import React from "react";
import methodology from "../../docs/Conser_methodology_short_2025.pdf";
import glossary from "../../docs/Conser_Check-ESG_Glossary EN_2025.pdf";
import {Tab, Tabs} from "react-bootstrap";
import Doc from "./Doc";

export default function Docs(props) {

    const FILES = [
        {key: 'methodo', label: 'Methodology', desc: 'Conser Methodology'},
        {key: 'glossary', label: 'Glossary', desc: 'Portfolio Check Glossary'}
    ];

    // ReactPDF
    //     .renderToStream(<MyDocument/>)
    //     .then(r => AdminService.saveStream(r))
    //     .then(() => console.log("done"));
    return (
        <div className="main-content">
            <Tabs defaultActiveKey="methodo" id="docs-tabs" transition={false}>
                <Tab eventKey="methodo" title={FILES[0].label}>
                    <Doc fileConf={FILES[0]} file={methodology}/>
                </Tab>
                <Tab eventKey="glossary" title={FILES[1].label}>
                    <Doc fileConf={FILES[1]} file={glossary}/>
                </Tab>
            </Tabs>
        </div>
    );
}
